
export default {
  countryList: state => state.countryList
}
